import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    // eslint-disable-next-line max-params
    createFetchParams: (selectedMonth, pagination, search, sort, exclude, entities) => ({
        ...pagination,
        ...search,
        ...entities,
        ordering:       sort,
        exclude,
        selected_month: Math.floor(selectedMonth / TIMESTAMP_MULTIPLY)
    }),
    ...storeModuleFactory({
        name:               'cloudBillingAccounts',
        endpoint:           endpoints.cloudBilling.accountsEndpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        transformResultsFn: item => ({
            ...item,
            total:         item.total_selected_month,
            totalPrevious: item.total_previous_month,
            count:         item.count,
            results:       item.results.map(account => ({
                id:                    account.id,
                alias:                 account.alias,
                name:                  account.alias,
                vendorAccountNumber:   account.vendor_account_number,
                spending:              account.spending_selected_month,
                previousSpending:      account.spending_previous_month,
                spendingSelectedMonth: account.spending_selected_month,
                spendingPreviousMonth: account.spending_previous_month,
                vendor:                {
                    code: account.vendor.code,
                    name: account.vendor.title
                }
            }))
        })
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/cloudBillingAccounts.js